import React, { useState, useEffect } from "react";
import "./Balance.css";
import { fetchWalletTxns } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Pagination from "../Components/Pagination";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";

const WalletTransactionTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const getWalletData = async () => {
      try {
        setIsLoading(true);

        const response = await fetchWalletTxns(token, currentPage);

        // console.log("Wallet Transactions Response:", response);

        setTableData(response?.data || []);
        setTotalPages(response?.data?.totalPages || 1);
      } catch (err) {
        toast.error(
          err?.response?.data?.message || err.message || "Something went wrong",
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      getWalletData();
    }
  }, [token, currentPage]);

  const formatAmount = (value) => `₹ ${Number(value || 0).toFixed(2)}`;

  const columns = [
    {
      key: "merchantName",
      header: "Merchant Name",
      render: (row) =>
        row.User_FundLoad_userIdToUser?.alias ||
        row.User_FundLoad_userIdToUser?.id ||
        "-",
    },
    {
      key: "previousBalance",
      header: "Previous Balance",
      render: (row) => formatAmount(row.previousBalance),
    },
    {
      key: "depositAmount",
      header: "Deposit Amount",
      render: (row) => formatAmount(row.depositAmount),
    },
    {
      key: "walletBalance",
      header: "Wallet Balance",
      render: (row) =>
        formatAmount(
          Number(row.previousBalance || 0) + Number(row.depositAmount || 0),
        ),
    },
    {
      key: "paymentMode",
      header: "Payment Mode",
      render: (row) => row.paymentMode || "-",
    },
    {
      key: "utr",
      header: "UTR",
      render: (row) => row.utr || "-",
    },

    ...(role !== "admin" && role !== "mops"
      ? [
          {
            key: "remark",
            header: "Remarks",
            render: (row) => row.remark || "-",
          },
        ]
      : []),

    {
      key: "loadedBy",
      header: "Wallet Loaded By",
      render: (row) =>
        row.User_FundLoad_loadedByToUser?.alias ||
        row.User_FundLoad_loadedByToUser?.id ||
        "-",
    },
    {
      key: "updatedAt",
      header: "Updated At",
      render: (row) =>
        row.updatedAt ? <DateCell date={row.updatedAt} /> : "N/A",
    },
  ];

  return (
    <div className="wallet-table-container">
      <h2 className="wallet-table-title">Wallet Transactions</h2>

      <DataTable
        columns={columns}
        data={tableData?.data || []}
        loading={isLoading}
        emptyMessage="No Records Found"
      />

      {!isLoading && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};

export default WalletTransactionTable;
